$(document).ready(function(){

    $('.catalog__select_recipe').change(function(){
      var cs = $(this).val();
      window.location = 'index.php?dir=site&page=recipes&op=category&cs=' + cs;
    });
    $('.lightgallery').lightGallery({
        selector: '.lightgallery-item'
      });
});
    